import ProductSection from "./ProductSection";

export default function PromoPage() {
    return (
        <ProductSection/>
    );
}